import { OpenStreetMapPoi, OpenStreetMapTypeValues } from 'components/common/types/OpenStreetMapPoi.types';
import { POI } from 'components/common/types/Planner.types';
import { POI_DEFAULT_RADIUS } from '../../PointsOfInterest/consts';
import { OPEN_STREET_MAP_DATA_PROVIDER } from './consts';

const DEFAULT_POI_PROPERTIES = {
  categoryType: '',
  categoryName: '',
  address: '',
  postalCode: '',
  dataProvider: '',
  mediaOwner: '',
  type: '',
};

export const getPoiCoordinates = (poiElement: OpenStreetMapPoi): [number, number] | null => {
  if (
    poiElement.type === OpenStreetMapTypeValues.NODE &&
    poiElement.lat !== undefined &&
    poiElement.lon !== undefined
  ) {
    return [poiElement.lon, poiElement.lat];
  }

  if (poiElement.type === OpenStreetMapTypeValues.WAY && poiElement.center) {
    return [poiElement.center.lon, poiElement.center.lat];
  }

  return null;
};

export const transformOpenStreetMapPoiToPlannerPoi = (
  openStreetMapPoiElements: OpenStreetMapPoi[],
  name: string,
  radius?: number,
): POI => {
  const resolvedRadius = radius ?? POI_DEFAULT_RADIUS;

  return {
    name,
    code: name,
    include: true,
    radius: resolvedRadius,
    dataProvider: OPEN_STREET_MAP_DATA_PROVIDER.value,
    hasChildren: false,
    rootCategoryType: '',
    parentCategory: '',
    categoryPath: '',
    tooltip: name,
    poiPoints: openStreetMapPoiElements
      .filter((element) => !!element.tags?.name)
      .map((poiElement) => {
        const coordinates = getPoiCoordinates(poiElement);
        if (!coordinates) return null;

        return {
          name: poiElement.tags.name!,
          geometry: {
            coordinates,
          },
          id: poiElement.id,
          isVisible: true,
          properties: {
            ...DEFAULT_POI_PROPERTIES,
            visibility: {
              include: true,
              radius: resolvedRadius,
            },
            isOpenStreetMapPoi: true,
          },
        };
      })
      .filter((item): item is NonNullable<typeof item> => item !== null),
  };
};

export const parseLocaleNumber = (localeFormattedNumber: string): number => {
  return Number(localeFormattedNumber.replace(/[^\d-]/g, ''));
};
